var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgc-p pb-20 mt-10 bdr-4"},[_c('h1',{staticClass:"color-w"},[_vm._v(_vm._s(_vm.title))]),_c('div',{style:({ width: '30rem', height: '15rem', padding: '0 1rem' }),attrs:{"id":"line"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }